import React, { useState } from 'react';

import Button from 'components/DesignSystem/Button';
import Dialog from 'components/DesignSystem/Dialog';
import TextField from 'components/DesignSystem/TextField';
import {
  ExplorerFolder, FOLDER_NAME_MAX_LENGTH, ROOT_LABEL, validateFolderName,
} from 'helper/products/fileExplorer';

import './index.scss';

const TITLE_ID = 'file-explorer-new-folder-title';

export default function NewFolderDialog({
  open,
  folder,
  isCreating,
  onCreate,
  onClose,
}: {
  open: boolean;
  folder: ExplorerFolder;
  isCreating: boolean;
  /** Devolve se a pasta foi criada (o diálogo só fecha nesse caso). */
  onCreate: (name: string) => Promise<boolean>;
  onClose: () => void;
}) {
  const [name, setName] = useState('');
  const siblings = folder.children.filter((child) => child.kind === 'folder').map((child) => child.name);
  const error = name ? validateFolderName(name, siblings) : null;
  const canSubmit = !!name.trim() && !error && !isCreating;

  const close = () => {
    setName('');
    onClose();
  };

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!canSubmit) return;
    if (await onCreate(name)) close();
  };

  return (
    <Dialog open={open} dismiss={close} centered closeButton labelledBy={TITLE_ID} className="file-explorer-new-folder">
      <form onSubmit={submit} noValidate>
        <Dialog.Body>
          <h2 id={TITLE_ID} className="file-explorer-dialog-title">Nova pasta</h2>
          <p className="file-explorer-dialog-subtitle">
            {`Em ${[ROOT_LABEL, ...folder.path].join(' / ')}`}
          </p>
          <TextField
            controlId="file-explorer-new-folder-name"
            label="Nome da pasta"
            value={name}
            onChange={(event) => setName((event.target as HTMLInputElement).value)}
            error={error ?? undefined}
            maxLength={FOLDER_NAME_MAX_LENGTH + 20}
            autoFocus
            autoComplete="off"
          />
        </Dialog.Body>
        <Dialog.Footer>
          <Button type="secondary" onClick={close}>Cancelar</Button>
          <Button submit disabled={!canSubmit}>
            {isCreating ? 'Criando…' : 'Criar pasta'}
          </Button>
        </Dialog.Footer>
      </form>
    </Dialog>
  );
}
